import { render, staticRenderFns } from "./GroupRule.vue?vue&type=template&id=6cf1fbd2&"
import script from "./GroupRule.vue?vue&type=script&lang=js&"
export * from "./GroupRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports